module.exports = __webpack_public_path__ + "static/img/image79_1.0be576e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/c34/image79_1.png
// module id = 6lW4
// module chunks = 0